module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("合同模板")])], 1)], 1)]), _vm._v(" "), _c('Form', [_c('Row', [_c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formData.id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id", $$v)
      },
      expression: "formData.id"
    }
  }, _vm._l((_vm.versionList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    style: ({
      marginLeft: '10px',
      marginRight: '10px'
    }),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onAdd(null, true)
      }
    }
  }, [_vm._v("新增模版")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onAdd(_vm.formData, false)
      }
    }
  }, [_vm._v("修改模版名称")])], 1)], 1), _vm._v(" "), _c('Row', [_c('div', {
    staticStyle: {
      "color": "red",
      "line-height": "24px"
    }
  }, [_c('p', [_vm._v("\n          合同中可以引用动态数据:\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          学生订单合同：{学生ID},{订单编号},{付款金额},{付款金额大写},\n          {课程有效期},{课时},{学生姓名英文},{学生姓名中文},{学生姓名中文繁体},{付款金额英文},{付款金额繁体}\n        ")]), _vm._v(" "), _c('p', [_vm._v("老师合同:{老师ID},{老师姓名},{合同开始时间},{合同结束时间},{签字时间}")])])])], 1), _vm._v(" "), _c('Row', [_c('quillEditor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "change": _vm.textChange
    },
    model: {
      value: (_vm.formData.contract),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contract", $$v)
      },
      expression: "formData.contract"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      marginTop: '10px'
    }),
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    style: ({
      marginLeft: '10px',
      marginRight: '10px'
    }),
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.openPreview
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新增/编辑"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名称",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, _vm._l((_vm.$constant.enabledStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b6f4478","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/data/ContractVersion.vue
// module id = 1748
// module chunks = 8